import queries from "./queries";

const doQuery = async (q, v) => {
  let token = localStorage.getItem('token')
  token = token ? token : 'd376b950c982ab44506a26130eeb07'
  let authorization = `Bearer ${token}`
  try {
    return await fetch("https://graphql.datocms.com", {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${authorization}`
      },
      body: JSON.stringify({
        query: q,
        variables: v
      })
    }).then(res => res.json());
  } catch (error) {
    console.log("QUERY ERROR", error, "on query", q);
    throw error;
  }
};

const doQuery2 = async (q, v) => {
  let token = localStorage.getItem('token')
  token = token ? token : 'd376b950c982ab44506a26130eeb07'
  let authorization = `Bearer ${token}`
  const url = new URL("https://graphql.datocms.com")
  const jsonQuery = JSON.stringify({
    query: q,
    variables: v
  })
  const jsonParse = JSON.stringify(JSON.parse(jsonQuery))

  url.searchParams.append("qobj", `${jsonParse}`)

  try {
    return await fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `${authorization}`,
      },
    }).then(res => res.json());
  } catch (error) {
    console.log("QUERY ERROR", error, "on query", q);
    throw error;
  }
};
const doQuery3 = async (q, v) => {
  let token = localStorage.getItem('token')
  token = token ? token : 'd376b950c982ab44506a26130eeb07'
  let authorization = `Bearer ${token}`
  const url = new URL("https://graphql.datocms.com")
  const jsonQuery = JSON.stringify({
    query: q,
    variables: v
  })

  url.searchParams.append("qobj", `${jsonQuery}`)
  try {
    return await fetch(url, {
      mode: "cors",
      cache: "no-cache",
      credentials: 'include',
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${authorization}`,
      },
    }).then(res => res.json());
  } catch (error) {
    console.log("QUERY ERROR", error, "on query", q);
    throw error;
  }
};
export default {
  doQuery,
  doQuery2,
  queries
};